export const SUBSCRIPTION_TIERS = ['starter', 'growth', 'enterprise'] as const;
export const BILLING_STATUSES = ['trial', 'current', 'past_due', 'cancelled', 'expired'] as const;
export const TENANT_ROLES = ['super_admin', 'front_desk'] as const;

export type SubscriptionTier = (typeof SUBSCRIPTION_TIERS)[number];
export type BillingStatus = (typeof BILLING_STATUSES)[number];

/** Published monthly list price in Moroccan dirham. Not collected payment. */
export const TIER_MONTHLY_MAD: Record<SubscriptionTier, number> = {
  starter: 490,
  growth: 1490,
  enterprise: 3990,
};

export const TIER_FEATURES: Record<SubscriptionTier, string[]> = {
  starter: ['1 branch', 'Public site', 'Contracts and signing'],
  growth: ['Multiple branches', 'Staff roles', 'Tariffs and caisse'],
  enterprise: ['Custom domain', 'Priority support', 'Qualified signature provider'],
};

export function isSubscriptionTier(value: string): value is SubscriptionTier {
  return (SUBSCRIPTION_TIERS as readonly string[]).includes(value);
}

export function isBillingStatus(value: string): value is BillingStatus {
  return (BILLING_STATUSES as readonly string[]).includes(value);
}

export function tierPrice(tier: string): number {
  return isSubscriptionTier(tier) ? TIER_MONTHLY_MAD[tier] : 0;
}

export function subscriptionMrr(
  agencies: { active: boolean; subscriptionTier: string; billingStatus: string }[],
  monthlyPrice: (tier: string) => number = tierPrice,
): number {
  return agencies.reduce((sum, agency) => {
    if (!agency.active || agency.billingStatus !== 'current') return sum;
    return sum + monthlyPrice(agency.subscriptionTier);
  }, 0);
}

export function contractedArr(monthlyRecurring: number): number {
  return Math.round(monthlyRecurring * 12 * 100) / 100;
}
